export const GET_LABEL_DATA_START = "GET_LABEL_DATA_START";
export const GET_LABEL_DATA_SUCCESS = "GET_LABEL_DATA_SUCCESS";
export const GET_LABEL_DATA_FAILURE = "GET_LABEL_DATA_FAILURE";
export const CREATE_LABEL_START = "CREATE_LABEL_START";
export const CREATE_LABEL_SUCCESS = "CREATE_LABEL_SUCCESS";
export const CREATE_LABEL_FAILURE = "CREATE_LABEL_FAILURE";
